import styled from "styled-components";
export const MainStyled = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  /* justify-content: center; */
  padding: 6px;
  border-radius: 14px;
  background-color: #fff;
  flex-wrap: wrap;
  /* overflow: hidden;
  touch-action: auto; */
`;
export const VehicleTypeStyled = styled.div`
  padding: 3px 12px;
  border-radius: 14px;
  background-color: #eaebed;
  margin: 3px 2px !important;; 
  color: #2a2e43;
  white-space: nowrap;
  &.selected {
    /* background-color: rgba(42, 46, 67, 0.1); */
    background-color: #2a2e43;
    color: #fff;
  }
`;
